<template>
  <div>
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('storeOrderCartFee.queryTitle') }}</div>
        <div class="ibox-tools" style="top:10px;"></div>
      </div>
      <div class="">
        <el-form :inline="true" :model="storeOrderCartFeeInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-form-item>
              <el-input v-model="storeOrderCartFeeInfo.conditions.feeName"
                :placeholder="$t('storeOrderCartFee.feeNamePlaceholder')" clearable />
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-form-item>
              <el-input v-model="storeOrderCartFeeInfo.conditions.cartId"
                :placeholder="$t('storeOrderCartFee.cartIdPlaceholder')" clearable />
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-form-item>
              <el-select v-model="storeOrderCartFeeInfo.conditions.state"
                :placeholder="$t('storeOrderCartFee.statePlaceholder')" style="width:100%" clearable>
                <el-option v-for="item in storeOrderCartFeeInfo.states" :key="item.statusCd" :label="item.name"
                  :value="item.statusCd" />
              </el-select>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="_queryStoreOrderCartFees">
              <i class="el-icon-search"></i> {{ $t('common.query') }}
            </el-button>
            <el-button size="small" @click="_resetStoreOrderCartFees">
              <i class="el-icon-refresh"></i> {{ $t('common.reset') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('storeOrderCartFee.orderFeeTitle') }}</div>
      </div>
      <div class="">
        <el-table :data="storeOrderCartFeeInfo.storeOrderCartFees" border style="width:100%">
          <el-table-column prop="cartId" :label="$t('storeOrderCartFee.cartId')" align="center" />
          <el-table-column prop="feeName" :label="$t('storeOrderCartFee.feeName')" align="center" />
          <el-table-column prop="price" :label="$t('storeOrderCartFee.price')" align="center" />
          <el-table-column prop="payPrice" :label="$t('storeOrderCartFee.payPrice')" align="center" />
          <el-table-column prop="payWayName" :label="$t('storeOrderCartFee.payWayName')" align="center" />
          <el-table-column prop="state" :label="$t('storeOrderCartFee.state')" align="center">
            <template #default="{ row }">
              {{ row.state === '1001' ? $t('storeOrderCartFee.unpaid') : $t('storeOrderCartFee.paid') }}
            </template>
          </el-table-column>
          <el-table-column prop="updateTime" :label="$t('storeOrderCartFee.updateTime')" align="center" />
          <el-table-column prop="remark" :label="$t('storeOrderCartFee.remark')" align="center" />
        </el-table>

        <el-pagination @current-change="handleCurrentChange" :current-page="storeOrderCartFeeInfo.conditions.page"
          :page-size="storeOrderCartFeeInfo.conditions.row" layout="total, prev, pager, next"
          :total="storeOrderCartFeeInfo.total" />
      </div>
    </el-card>
  </div>
</template>

<script>
import { getDict } from '@/api/shop/shopApi'
import { getShopId } from '@/api/shop/shopApi'
import { queryStoreOrderCartFee } from '@/api/order/storeOrderCartFeeApi'

export default {
  name: 'StoreOrderCartFee',
  data() {
    return {
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 10,
      storeOrderCartFeeInfo: {
        storeOrderCartFees: [],
        total: 0,
        records: 1,
        states: [],
        conditions: {
          feeName: '',
          state: '',
          cartId: '',
          shopId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this.shopId = getShopId()
    this.storeOrderCartFeeInfo.conditions.shopId = this.shopId
    this._initMethod()
  },
  methods: {
    async _initMethod() {
      await this._listStoreOrderCartFees(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
      try {
        const { data } = await getDict('store_order_cart_fee', 'state')
        this.storeOrderCartFeeInfo.states = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    async _listStoreOrderCartFees(page, rows) {
      this.storeOrderCartFeeInfo.conditions.page = page
      this.storeOrderCartFeeInfo.conditions.row = rows
      const params = {
        ...this.storeOrderCartFeeInfo.conditions,
        feeName: this.storeOrderCartFeeInfo.conditions.feeName.trim(),
        cartId: this.storeOrderCartFeeInfo.conditions.cartId.trim()
      }

      try {
        const res = await queryStoreOrderCartFee(params)
        this.storeOrderCartFeeInfo.total = res.total
        this.storeOrderCartFeeInfo.records = res.records
        this.storeOrderCartFeeInfo.storeOrderCartFees = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _queryStoreOrderCartFees() {
      this._listStoreOrderCartFees(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    _resetStoreOrderCartFees() {
      this.storeOrderCartFeeInfo.conditions.feeName = ""
      this.storeOrderCartFeeInfo.conditions.cartId = ""
      this.storeOrderCartFeeInfo.conditions.state = ""
      this._listStoreOrderCartFees(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    handleCurrentChange(val) {
      this._listStoreOrderCartFees(val, this.DEFAULT_ROWS)
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, .1);
}

.ibox-title {
  border-bottom: 1px solid #e7eaec;
  padding: 15px 15px 7px;
  min-height: 48px;
}

.ibox-content {
  clear: both;
  padding: 15px 20px 20px;
}
</style>